import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import ChartTypeDetector from '../components/mixins/charts/type_detector'
import MobileDetection from '../components/mixins/mobiledetection'

import BookmarkButton from '../components/bookmark'
import Chart from '../components/indicators/chart'
import ChartType from '../components/indicators/chart_type'
import Filter from '../components/indicators/filter'
import FollowButton from '../components/follow'

Vue.use(BootstrapVue)

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    data: {
      filters: window.hasOwnProperty('DEFAULT_FILTERS') ? DEFAULT_FILTERS : {},
      showBy: window.hasOwnProperty('DEFAULT_SHOW_BY') ? DEFAULT_SHOW_BY : null,
      type: window.hasOwnProperty('DEFAULT_TYPE') ? DEFAULT_TYPE : null,
      iframeBackground: null,
      iframeHeight: 650,
			showTitle: false
    },
    computed: {
      showShowBy: function() {
        return (this.isPie(this.type) && Object.keys(this.filters).length > 1) || !this.isPie(this.type)
      },
      shareLink: function() {
				console.log(this.showTitle)
        let params = `?type=${this.type}&show_by=${this.showBy}&height=${this.iframeHeight}&show_title=${this.showTitle}`
        for (let key in this.filters) params += `&filters[${key}]=${this.filters[key]}`
        if (this.iframeBackground && this.iframeBackground.length > 0) params += `&background=${escape(this.iframeBackground)}`
        return `${document.location.origin}${window.hasOwnProperty('DEFAULT_LINK') ? DEFAULT_LINK : ''}${params}`
      },
    },
    methods: {
      copy: function() {
        this.$refs['share-text'].disabled = null
        this.$refs['share-text'].select()
        document.execCommand('copy')
        this.$refs['share-text'].blur()
        this.$refs['share-text'].disabled = 'disabled'
      }
    },
    mixins: [
      ChartTypeDetector,
      MobileDetection,
    ],
    components: {
      'b-bookmark-button': BookmarkButton,
      'b-chart': Chart,
      'b-chart-type': ChartType,
      'b-filter': Filter,
      'b-follow-button': FollowButton,
    },
  }).$mount('#vue-app')
})



// WEBPACK FOOTER //
// app/javascript/packs/vue_application.js